import React from 'react';
import { User, History, Settings, LogOut, Gift } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const AccountSidebar = ({ activeTab, setActiveTab, userProfile, isMobile }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { firstName, lastName } = userProfile;

  // Handle sign out
  const handleSignOut = async () => {
    const success = await logout();
    if (success) {
      navigate('/login');
    }
  };

  if (isMobile) {
    // Mobile tabs
    return (
      <div className="flex overflow-x-auto pb-2 mb-4 border-b border-gray-200">
        <button 
          onClick={() => setActiveTab('profile')}
          className={`px-4 py-2 whitespace-nowrap text-sm font-medium ${activeTab === 'profile' 
            ? 'text-[#3A98B9] border-b-2 border-[#3A98B9]' 
            : 'text-gray-600'}`}
        >
          Profile
        </button>
        <button 
          onClick={() => setActiveTab('appointments')}
          className={`px-4 py-2 whitespace-nowrap text-sm font-medium ${activeTab === 'appointments' 
            ? 'text-[#3A98B9] border-b-2 border-[#3A98B9]' 
            : 'text-gray-600'}`}
        >
          Appointments
        </button>
        <button 
          onClick={() => setActiveTab('vehicles')}
          className={`px-4 py-2 whitespace-nowrap text-sm font-medium ${activeTab === 'vehicles' 
            ? 'text-[#3A98B9] border-b-2 border-[#3A98B9]' 
            : 'text-gray-600'}`}
        >
          Vehicles
        </button>
        <button 
          onClick={() => setActiveTab('gift-cards')}
          className={`px-4 py-2 whitespace-nowrap text-sm font-medium ${activeTab === 'gift-cards' 
            ? 'text-[#3A98B9] border-b-2 border-[#3A98B9]' 
            : 'text-gray-600'}`}
        >
          Gift Cards
        </button>
      </div>
    );
  }

  // Desktop sidebar
  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden">
      <div className="p-6 bg-gradient-to-r from-[#3A98B9] to-[#2A87A8] text-white">
        <div className="flex items-center">
          <div className="h-12 w-12 rounded-full bg-white/20 flex items-center justify-center">
            <User className="h-6 w-6" />
          </div>
          <div className="ml-4">
            <h3 className="font-semibold">{firstName} {lastName}</h3>
            <p className="text-sm text-white/80">Premium Member</p>
          </div>
        </div>
      </div>
      
      <nav className="p-4">
        <button 
          onClick={() => setActiveTab('profile')}
          className={`flex items-center w-full px-4 py-3 rounded-lg mb-1 ${
            activeTab === 'profile' 
              ? 'bg-[#3A98B9]/10 text-[#3A98B9]' 
              : 'text-gray-700 hover:bg-gray-100'
          }`}
        >
          <User className="h-5 w-5 mr-3" />
          <span>Profile</span>
        </button>
        
        <button 
          onClick={() => setActiveTab('appointments')}
          className={`flex items-center w-full px-4 py-3 rounded-lg mb-1 ${
            activeTab === 'appointments' 
              ? 'bg-[#3A98B9]/10 text-[#3A98B9]' 
              : 'text-gray-700 hover:bg-gray-100'
          }`}
        >
          <History className="h-5 w-5 mr-3" />
          <span>Appointments</span>
        </button>
        
        <button 
          onClick={() => setActiveTab('vehicles')}
          className={`flex items-center w-full px-4 py-3 rounded-lg mb-1 ${
            activeTab === 'vehicles' 
              ? 'bg-[#3A98B9]/10 text-[#3A98B9]' 
              : 'text-gray-700 hover:bg-gray-100'
          }`}
        >
          <Settings className="h-5 w-5 mr-3" />
          <span>My Vehicles</span>
        </button>
        
        <button 
          onClick={() => setActiveTab('gift-cards')}
          className={`flex items-center w-full px-4 py-3 rounded-lg mb-1 ${
            activeTab === 'gift-cards' 
              ? 'bg-[#3A98B9]/10 text-[#3A98B9]' 
              : 'text-gray-700 hover:bg-gray-100'
          }`}
        >
          <Gift className="h-5 w-5 mr-3" />
          <span>Gift Cards</span>
        </button>
        
        <div className="border-t border-gray-200 my-2 pt-2">
          <button 
            onClick={handleSignOut}
            className="flex items-center w-full px-4 py-3 rounded-lg text-red-600 hover:bg-red-50"
          >
            <LogOut className="h-5 w-5 mr-3" />
            <span>Sign Out</span>
          </button>
        </div>
      </nav>
    </div>
  );
};

export default AccountSidebar;